import React from 'react';
import MyTasksCommon from '../_myTasksCommon';

export default props => (
  <MyTasksCommon
    {...props}
    staticQueryParams={{
      status: 6
    }}
  />
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/MyPremoderationTasksList/MyPremoderationTasksList.js